//Routing
export const APP_ROUTES = {
  login: 'login',
  home: 'home',
};